/* eslint-disable react/no-danger */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

import { getImageAtSize } from '../../lib/utils';

import Body from '../typography/Body';

import testImage from '../../../img/folklore.png';
import styles from '../../../styles/blocks/quote.module.css';

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
    }).isRequired,
    text: PropTypes.string,
    author: PropTypes.string,
    url: PropTypes.string,
    external: PropTypes.bool,
    withSize: PropTypes.bool,
    padded: PropTypes.bool,
    className: PropTypes.string,
    imgClassName: PropTypes.string,
    textClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function QuoteBlock({
    image = null,
    text = null,
    author = null,
    url = null,
    external = true,
    withSize = false,
    padded = false,
    className = null,
    imgClassName = null,
    textClassName = null,
    isContainer = false,
    containerClassName = null,
}) {
    const { alt = null } = image || {};
    const {
        width = 0,
        height = 0,
        url: imageUrl = null,
    } = getImageAtSize(image || { url: testImage }, 'medium', false);

    const hasSize = withSize && width !== 0 && height !== 0;

    const imageElement =
        imageUrl !== null ? (
            <img
                className={classNames([styles.avatar, { [imgClassName]: imgClassName !== null }])}
                src={imageUrl}
                alt={alt || text}
                width={hasSize ? width : null}
                height={hasSize ? height : null}
            />
        ) : (
            imageUrl
        );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {!isEmpty(text) ? (
                    <blockquote
                        className={classNames([
                            styles.blockquote,
                            { [textClassName]: textClassName !== null },
                        ])}
                    >
                        <Body className={styles.quote} body={text} size="medium" />
                    </blockquote>
                ) : null}
                <div className={styles.source}>
                    {url !== null ? (
                        <a
                            className={styles.link}
                            href={url}
                            target={external ? '_blank' : null}
                            rel={external ? 'noopener noreferrer' : null}
                        >
                            {imageElement}
                        </a>
                    ) : (
                        imageElement
                    )}
                    {!isEmpty(author) ? (
                        <div className={styles.authorContainer}>
                            <Body className={styles.author} body={author} />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

QuoteBlock.propTypes = propTypes;

export default QuoteBlock;
